import React, { createContext, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { PureAbility, AbilityBuilder } from '@casl/ability'
import { createCanBoundTo } from '@casl/react'
import { authAction, notificationAction, sessionAction } from '../redux/actions'
import { useBoolean, useToast } from '@chakra-ui/react'
import { configureAbly, useChannel } from "@ably-labs/react-hooks"
import { v4 as uuidv4 } from 'uuid';


const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const  Ability = new PureAbility([]);
const Can = createCanBoundTo(Ability);

const initialState = {
    user: null,   
    token: localStorage.getItem(accessToken)
};

const AppContext = createContext({
    ...initialState,
    init: () => Promise.resolve(),
    login: () => Promise.resolve(),     
    logout: () => Promise.resolve(),
});

configureAbly({ key: process.env.REACT_APP_ABLY_KEY, clientId: uuidv4() });

export const AppProvider = (props) => {
    const toast = useToast()
    const auth = useSelector(state => state.auth);    
    const active_session = useSelector(state => state?.sessions?.active)
    const [state, setState] = useState({...initialState})    
    const [ mount, setMount] = useBoolean()
    const [ loading, setLoading ] = useBoolean()
    const dispatch = useDispatch()
    const audio = new Audio('/assets/bell.mp3');


    const playSound = () => {                
        audio.play();        
    };

    
    // useChannel("public:admin", (message) => {
    //     console.log(message)
    //     // alert(process.env.REACT_APP_API_URL+"download/"+message?.data?.user, "File Download");
    // });

    useChannel("public:export", (message) => {
        // console.log("Message Recieved")        
        console.log(message?.data?.payload)
        dispatch(notificationAction.add(message?.data?.payload));        
        playSound()
        toast({
            title:  message?.data?.payload?.payload?.title,
            description:  message?.data?.payload?.payload?.message,
            status: "success",
            position: "top-right",
            isClosable: true,
            duration: 3000
        })

        // alert(process.env.REACT_APP_API_URL+"download/"+message?.data?.user, "File Download");
    });


    const login = (form_data) => {
        return new Promise((resolve, reject) => {
            dispatch(authAction.clear())
            .then(() => {
                return dispatch(authAction.login(form_data))
            })            
            .then((response) => {
                resolve(response) 
            })
            .catch((error) => reject(error) )
        })

    }

    const logout = () => {
        return new Promise((resolve, reject) => {
            dispatch(authAction.logout())        
                .then(() => {                        
                    resolve()
                })
                .catch((e) => {
                    reject()
                })
        })

    }

    

    useEffect(() => {
        const init = async () => {   
            setLoading.on()                      
            try{
                await dispatch(authAction.auth_check())
                await dispatch(sessionAction.active())
                setMount.on()
                setLoading.off()
            }
            catch(err){                                
                console.log("Auth Error", err)
                setMount.on()
                setLoading.off()
            }
        }
        if(!mount && !loading){
            init()                  
        }
        

    }, [mount, setMount, state, loading, setState, setLoading, dispatch])

    useEffect(() => {
        if(auth?.user && auth?.user?.permissions && auth?.user?.permissions?.length > 0){            
            const { can, rules } = new AbilityBuilder();
            let permissions = auth?.user?.permissions
            let actions = [];
            permissions?.map((permit, p) => {
                let permission = permit.split(' ')
                actions.push(permission[0])
                return can(permission[0], permission[1])                
            })
            Ability.update(rules);
        }

        if(auth?.user && auth?.user?.sa){
            const { can, rules } = new AbilityBuilder();
            can('manage', 'all');
            Ability.update(rules);    
        }
                
    }, [auth?.user])
    
    
    console.log("Current Session", active_session)
    return (
        <AppContext.Provider
            value={{
                ...state,
                ...auth,
                active_session,
                // config,
                loading,
                Ability,
                Can,
                setLoading,                
                login,
                logout
            }}>
            {props.children}
            
        </AppContext.Provider>
    );
}

export  {AppContext}